import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcAdmin = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M12 8c0 1.401-.72 2.634-1.812 3.349.792.26 1.52.658 2.16 1.164a3 3 0 0 0-.612 1.815v4.345c0 .11.006.22.018.327H2a1 1 0 0 1-1-1 7.003 7.003 0 0 1 4.812-6.651A4 4 0 1 1 12 8Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M19 11.29a1 1 0 0 0-1 0l-3.764 2.172a1 1 0 0 0-.5.866v4.345a1 1 0 0 0 .5.866L18 21.712a1 1 0 0 0 1 0l3.763-2.173a1 1 0 0 0 .5-.866v-4.345a1 1 0 0 0-.5-.866l-3.764-2.173Zm-.5 6.961a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcAdmin");

export { IcAdmin };
//# sourceMappingURL=ic-admin.js.map
